// Displays a report of tickets closed within a specified date range
// broken down by hour and date categories. The table headers are hours
// from 0 to 23, and the rows represent date range selected by the user.

import React from 'react';
import styles from '../css/inTicketsReport.module.css';
import { useRef } from 'react';
import { addHoursHeaders, getDatesInRange } from '../helpers/timeDifference.js';
import SimpleExportToExcel from '../components/SimpleExportToExcel';

function ClosedTicketsReport({ data, totalOutTickets, start, end }) {
  const tableRef = useRef([]);
  const tableExportRef = useRef(null);

  return (
    <div className={styles.tableContainer}>
      <div className={styles.reportContentContainer}>
        <div className={styles.exportContainer}>
          <SimpleExportToExcel data={data} targetTableRef={tableExportRef} reportName={'OutTickets'} />
        </div>
        {data.length > 0 && (
          <table ref={tableExportRef} className={styles.mainTable}>
            <caption>Out Traffic Report</caption>
            <thead>
              <tr>
                <th>Date</th>
                {addHoursHeaders(tableRef.current).map((hour) => (
                  <th key={hour.id}>{hour}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {getDatesInRange(start, end).map((date, i) => {
                const rowDate = new Date(date);
                return (
                  <tr key={i}>
                    <td key={i + 1}>{date}</td>
                    {tableRef.current.map((hour, hourIndex) => {
                      const match = data.find((item) => {
                        const d = new Date(item.DateOut);
                        return (
                          d.getFullYear() === rowDate.getFullYear() &&
                          d.getMonth() === rowDate.getMonth() &&
                          d.getDate() === rowDate.getDate() &&
                          Number(item.HourOut) === Number(hour)
                        );
                      });
                      if (hourIndex <= 23) {
                        return <td key={hourIndex}>{match ? match.closedTickets : 0}</td>;
                      } else {
                        return null;
                      }
                    })}
                    {data.map((targetDate, targetIndex) => {
                      const totalOutForData = data
                        .filter((dataItem) => {
                          const d = new Date(dataItem.DateOut);
                          return (
                            d.getFullYear() === rowDate.getFullYear() &&
                            d.getMonth() === rowDate.getMonth() &&
                            d.getDate() === rowDate.getDate()
                          );
                        })
                        .reduce((acc, curr) => Number(acc) + Number(curr.closedTickets), 0);
                      if (targetIndex === 0) {
                        return (
                          <td
                            key={targetIndex}
                            style={{
                              fontWeight: 'bold',
                            }}
                          >
                            {Number(totalOutForData)}
                          </td>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </tr>
                );
              })}
              <tr>
                <td
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  Total
                </td>
                {tableRef.current.map((hour, hourIndex) => {
                  const totalForHour = data
                    .filter((hourFilter) => {
                      return Number(hourFilter.HourOut) === Number(hour);
                    })
                    .reduce((acc, item) => Number(acc) + Number(item.closedTickets), 0);
                  if (hourIndex <= 23) {
                    return (
                      <td
                        key={hourIndex}
                        style={{
                          fontWeight: 'bold',
                        }}
                      >
                        {totalForHour}
                      </td>
                    );
                  } else if (hourIndex === 24) {
                    return (
                      <td
                        key={hourIndex}
                        style={{
                          fontWeight: 'bold',
                        }}
                      >
                        {totalOutTickets}
                      </td>
                    );
                  } else {
                    return null;
                  }
                })}
              </tr>
              <tr>
                <td
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  Percentage
                </td>
                {tableRef.current.map((hour, hourIndex) => {
                  const percentPerHour = data
                    .filter((hourFilter) => {
                      return Number(hourFilter.HourOut) === Number(hour);
                    })
                    .reduce(
                      (percentSum, percentCurrentValue) =>
                        Number(percentSum) + (Number(percentCurrentValue.closedTickets) / totalOutTickets) * 100,
                      0,
                    );
                  if (hourIndex <= 23) {
                    return (
                      <td
                        key={hourIndex}
                        style={{
                          fontWeight: 'bold',
                          fontSize: '14.2px',
                        }}
                      >
                        {percentPerHour.toFixed(1) + '%'}
                      </td>
                    );
                  } else if (hourIndex === 24) {
                    return (
                      <td
                        key={hourIndex}
                        style={{
                          fontWeight: 'bold',
                        }}
                      >
                        100%
                      </td>
                    );
                  } else {
                    return null;
                  }
                })}
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ClosedTicketsReport;
